import * as React from "react";
import {viewType} from "./App";
import * as MonumentIcon from '../../assets/_img/kleindenkmal.svg';
interface Props {
	result: any; // TODO: Type!
    view: viewType;
    isFirstElement: boolean
}

export default class Result extends React.Component<Props, any> {
    private resultRef: React.RefObject<any>;
    constructor(props: Props) {
        super(props);
        this.resultRef = React.createRef();
    }
	componentDidMount() {
        if (this.props.isFirstElement){
            this.resultRef.current?.focus();
        }
	}

	render() {
		// TODO: Listenansicht


        const source = this.props.result;
		// @ts-ignore
        const image = (source.banner ) ? <figure className={"image"}><img  src={source.banner} alt={''} title={""} /></figure> : <figure className={"image fallback"}><img  src={MonumentIcon} alt={''} title={""} /></figure>;
		return (
			<li className={`result col ${this.props.view === 'grid' ? 'col-md-4 col-sm-6' : ''} ${this.props.view} col-12`}>
				<a href={source.url} ref={this.resultRef} title={"zu den weiteren Informationen"}>
                    <div className={`result-content`}>
                        <h2 className={'h3 hyphenate'}>
                            <strong>{source.category}</strong>
                            <span>{source.district}</span>
                            <span>{source.location}</span>
                        </h2>
                    </div>
                    {image}
				</a>
			</li>
		)
	}
}
